import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import LoginBrandPanel from "@/components/LoginBrandPanel";
import { useLoginForm } from "@/hooks/useLoginForm";
import { Home, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Login() {
  const { email, setEmail, password, setPassword, error, loading, onSubmit } = useLoginForm();

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <LoginBrandPanel />
      <div className="flex items-center justify-center p-6 sm:p-12 bg-[#F8FAFC]">
        <div className="w-full max-w-md animate-fade-up">
          <div className="flex items-center justify-between mb-8">
            <div className="lg:hidden flex items-center gap-3">
              <Logo />
              <span className="text-lg font-head font-bold">Shri Ji Clinic</span>
            </div>
            <Link to="/" data-testid="login-home-link" className="ml-auto inline-flex items-center gap-2 text-sm text-slate-500 hover:text-teal-700 transition-colors">
              <Home className="h-4 w-4" /> Back to Home
            </Link>
          </div>
          <h2 className="font-head text-3xl font-bold tracking-tight text-slate-900">Staff Login</h2>
          <p className="text-slate-500 mt-2 mb-8 text-sm">Sign in to manage appointments and receipts.</p>

          <form onSubmit={onSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-slate-700">Email</Label>
              <Input id="email" type="email" data-testid="admin-login-email-input" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@hospital.com" className="h-12 bg-white" autoComplete="username" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-slate-700">Password</Label>
              <Input id="password" type="password" data-testid="admin-login-password-input" value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" className="h-12 bg-white" autoComplete="current-password" required />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2">{error}</div>
            )}
            <Button type="submit" data-testid="admin-login-submit-button" disabled={loading}
              className="w-full h-12 bg-teal-600 hover:bg-teal-700 text-white text-base font-semibold">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
